import { useEffect, useRef, useState } from "react";
import ModalComponent from "../../common/ModalComponent";
import { addRAGCorpusAPI, addRAGCorpusFileAPI, createAgentAPI, getRAGCorpusAPI } from "../../../service/ai-model.service";
import { useAppContext } from "../../../context/app.context";
import { ToastType } from "../../../helper/constant";
import CustomLoader from "../../common/CustomLoader";
import { Form } from "react-bootstrap";
import CustomDropdown from "../../common/CustomDropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faTrashCan, faUpload, faXmark } from "@fortawesome/free-solid-svg-icons";

export const GENERATIVE_AGENT_TYPE = {
    RESEARCH: 'RESEARCH'
}

const AddRagCorpusDialog = ({ showModal, setShowModal, title }) => {

    const [corpusName, setCorpusName] = useState('');
    const [corpusDescription, setCorpusDescription] = useState('');
    const [files, setFiles] = useState(null);
    const { showAlert } = useAppContext();
    const [loading, setLoading] = useState(false);
    const [existingRagCorpus, setExistingRagCorpus] = useState([]);
    const [selectedRagCorpus, setSelectedRagCorpus] = useState(null);
    const fileRef = useRef();

    useEffect(() => {
        if (showModal) {
            setCorpusName('');
            setCorpusDescription('');
            setFiles(null);
            fileRef.current = null;
            getExistingRagCorpus();
            setSelectedRagCorpus(null);
        }
    }, [showModal]);

    const getExistingRagCorpus = () => {
        getRAGCorpusAPI().then((response) => {
            if (response && response.corpora && response.corpora.length) {
                setExistingRagCorpus(response.corpora);
            }
        }).catch((error) => {
            showAlert("Failed to fetch existing Corpus.", ToastType.ERROR);
        });
    }

    const onAddCorpusSubmit = (e) => {
        e.preventDefault();
        if (!corpusName) {
            showAlert("Please fill in all required fields.", ToastType.ERROR);
            return;
        }
        setLoading(true);
        const payload = {
            name: corpusName,
            description: corpusDescription
        };
        addRAGCorpusAPI(payload)
            .then((response) => {
                if (response && response.corpus) {
                    uploadCorpusFile(response.corpus.id);
                } else {
                    showAlert("Failed to save", ToastType.ERROR);
                    setLoading(false);
                }
            })
            .catch((error) => {
                showAlert(error.message || "Failed to save", ToastType.ERROR);
                setLoading(false);
            });
    }

    const uploadCorpusFile = (id) => {
        if (!files) {
            showAlert("Select upload File.", ToastType.ERROR);
            return;
        }

        setLoading(true);
        const payload = new FormData();
        payload.append('files', files);
        addRAGCorpusFileAPI(payload, id)
            .then((response) => {
                if (response) {
                    showAlert("Corpus saved !", ToastType.SUCCESS);
                    getExistingRagCorpus();
                    fileRef.current = null;
                    setFiles(null);
                } else {
                    showAlert("Failed to save ", ToastType.ERROR);
                }
            })
            .catch((error) => showAlert(error.message || "Failed to save ", ToastType.ERROR))
            .finally(() => { setLoading(false) });
    }

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length) {
            setFiles(e.target.files[0]);
        }
    };

    const renderAddCorpus = () => {
        if (loading) {
            return (<div className="d-flex justify-content-center"><CustomLoader /></div>);
        }
        return (
            <button type="submit" className="btn btn-primary">Add Corpus</button>
        )
    }

    const renderUpdateCorpus = () => {
        if (loading) {
            return (<div className="d-flex justify-content-center"><CustomLoader /></div>);
        }
        const corpus = existingRagCorpus.filter(item => item.id === selectedRagCorpus)[0];
        return (
            <button type="button" className="btn btn-primary" onClick={() => uploadCorpusFile(corpus.id)}>Update Corpus</button>
        )

    }

    const renderExistingAgents = () => {
        if (!existingRagCorpus.length) {
            return null;
        }
        return (
            <>
                <div className="d-flex flex-column mb-2 gap-0">
                    <div className="font-weight-bold mb-2">Existing RAG Corpus</div>
                    <div className="w-80">
                        <CustomDropdown
                            showResearch
                            name=""
                            options={existingRagCorpus}
                            field="name"
                            value={selectedRagCorpus}
                            onChange={(e) => setSelectedRagCorpus(e)}
                        />
                    </div>
                </div>
            </>
        );
    };

    const renderUploadFile = () => {
        return (
            <>
                <div className="d-flex flex-column gap-1">
                    <div className="upload-btn-wrapper cursor-pointer w-50">
                        <button type="button" className="btnupld-blu w-100">
                            Upload <FontAwesomeIcon icon={faUpload} />
                        </button>
                        <input
                            ref={fileRef}
                            type="file"
                            name="myfile"
                            onChange={handleFileChange}
                        />
                    </div>
                    {files && <div className="d-flex align-items-center gap-2">
                        <div>{files.name}</div>
                        <div className="cursor-pointer" onClick={() => {
                            setFiles(null);
                            fileRef.current = null;
                        }}>
                            <FontAwesomeIcon icon={faXmark} className="text-danger" /></div>
                    </div>}
                </div>
            </>
        )
    }

    const renderAddAgentForm = () => {
        return (
            <>
                {(existingRagCorpus.length > 0) && <div className="d-flex flex-column gap-1 flex-1">
                    {renderExistingAgents()}
                    {selectedRagCorpus && renderSelectedCorpusDetails()}
                </div>
                }
                <div className={`d-flex flex-column gap-1 flex-1 ${existingRagCorpus.length > 0 ? 'border-left border-1 pl-5' : ''}`}>
                    <p>Please fill in the Corpus details below:</p>
                    <form className="d-flex flex-column gap-3" onSubmit={onAddCorpusSubmit} noValidate>
                        <div className="pb-2">
                            <div className="h6 f-13">
                                <b>Corpus Name</b> <span className="text-danger">*</span>
                            </div>
                            <input
                                type="text"
                                className="form-control py-1 px-2"
                                placeholder="Corpus Name"
                                value={corpusName}
                                onChange={(e) => setCorpusName(e.target.value)}
                                name="corpusName"
                            />
                        </div>
                        <div className="pb-2">
                            <div className="h6 f-13">
                                <b>Corpus Description</b> <span className="text-danger">*</span>
                            </div>
                            <input
                                type="text"
                                className="form-control py-1 px-2"
                                placeholder="Corpus description"
                                value={corpusDescription}
                                onChange={(e) => setCorpusDescription(e.target.value)}
                                name="corpusDescription"
                            />
                        </div>
                        {renderUploadFile()}
                        {renderAddCorpus()}
                    </form>
                </div >
            </>
        );
    }

    const renderSelectedCorpusDetails = () => {
        const corpus = existingRagCorpus.filter(item => item.id === selectedRagCorpus);
        if (corpus.length > 0) {
            return (
                <div className="d-flex gap-2 flex-column">
                    <p className="m-0 p-0 bold capitalize">{corpus[0].name}</p>
                    <ul>
                        {(corpus[0].list && corpus[0].list.length > 0) && corpus[0].list.map((item, fileIndex) => <li className="text-blue" key={fileIndex}><FontAwesomeIcon className="mr-2" icon={faFile} />{item.fileName}</li>)}
                    </ul>
                    {renderUploadFile()}
                    {renderUpdateCorpus()}
                </div>
            )
        }
    }

    const render = () => {
        return (
            <ModalComponent
                full
                title="Manage RAG Corpus"
                show={showModal}
                handleClose={setShowModal}
                classes={'w-50'}
            >
                <div className="d-flex flex-row gap-2">
                    {renderAddAgentForm()}
                </div>
            </ModalComponent>
        )
    }
    return render();
}

export default AddRagCorpusDialog;